import { render } from "./AppGenderSelect.vue?vue&type=template&id=29d34b35"
import script from "./AppGenderSelect.vue?vue&type=script&lang=ts"
export * from "./AppGenderSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script